<template>
  <McGrapqlTable
    :fields="fields"
    :isSelectableField="false"
    :searchable="true"
    :withCard="false"
    :customHandlers="customHandlers"
    :apiClient="query"
    trackBy="labourId"
    :customToast="customToast"
    :isEmpty="noData"
    :isLoading="isLoading"
  >
    <template #viewManager="{ handleSetDataFields, dataFields, initialFields }">
      <McFilterSelect
        :defaultColumnOrder="initialFields"
        :currentColumnOrder="dataFields"
        @setColumn="handleSetDataFields"
      />
    </template>
    <template #cell(fee)="data"> {{ `Rp ${thousandFormat(data.value)}` }} </template>
    <template #emptyState>
      <McEmptyState
        :title="$t('master.service.emptyState.title')"
        :desc="$t('master.service.emptyState.desc')"
        @buttonPrimaryAction="customHandlers.handleAdd"
        class="pb-4"
      ></McEmptyState>
    </template>
  </McGrapqlTable>
</template>

<script>
import McGrapqlTable from '@/components/McGrapqlTable'
import McFilterSelect from '@/components/McFilterSelect'
import { GET_LABOURS, DELETE_LABOUR } from '@/services/api/master/services'
import { Helper } from '@/mixin/helper'
import McEmptyState from '@/components/McEmptyState'

export default {
  components: {
    McGrapqlTable,
    McFilterSelect,
    McEmptyState,
  },

  mixins: [Helper],

  data() {
    return {
      customHandlers: {
        handleClickRow: (data) => {
          this.$router.push({
            name: 'Update Master Service Maintenance',
            params: { id: data.labourId },
          })
        },
        handleAdd: () => {
          this.$router.push({
            name: 'Add Master Service Maintenance',
          })
        },
      },
      noData: true,
      isLoading: true,
    }
  },

  computed: {
    fields() {
      return [
        {
          key: 'code',
          label: this.$t('master.service.serviceCode'),
          sortable: true,
          isRedirectable: true,
          isLocked: true,
        },
        {
          key: 'name',
          label: this.$t('master.service.name'),
          sortable: true,
        },
        {
          key: 'description',
          label: this.$t('master.service.description'),
          sortable: true,
        },
        {
          key: 'fee',
          label: this.$t('master.service.price'),
          sortable: true,
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          this.isLoading = true

          const res = await this.$apollo.query({
            query: GET_LABOURS,
            fetchPolicy: 'no-cache',
            variables: {
              filter: filter,
            },
          })

          if (res.data.labours.labours.pagination.total === 0) this.noData = true
          else this.noData = false
          this.isLoading = false

          return res.data.labours.labours
        },
        delete: async (id) => {
          const res = await this.$apollo.query({
            query: DELETE_LABOUR,
            fetchPolicy: 'no-cache',
            variables: {
              input: {
                labourId: +id,
              },
            },
          })

          return res.data.deleteLabour.isSuccessful
        },
      }
    },
  },

  methods: {
    customToast() {
      this.$mcToast.error({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            {
              tag: 'h6',
              text: this.$t('maintenance.alert.deleteFailed'),
            },
            {
              tag: 'p',
              text: this.$t('maintenance.alert.failedDeteleUsed'),
            },
          ],
        },
      })
    },
  },
}
</script>
